import functions from "./functions.js";

$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();

        $form.find('.contact-btn').addClass('d-none');
        $form.find('.contact-spinner').removeClass('d-none');
        $form.find('.contact-spinner').addClass('d-flex');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        grecaptcha.ready(function () {
            grecaptcha.execute('6LeitgwoAAAAALtpc4QpNvflq8PKj2nyN7glm6qu', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                $.post('/services/contact/', params).then(response => {

                    response = JSON.parse(response);

                    $('#contact-modal').modal('show');
                    $("#contact-modal .response-output").html(response.data);

                    $form.find('.contact-btn').removeClass('d-none');
                    $form.find('.contact-spinner').removeClass('d-flex');
                    $form.find('.contact-spinner').addClass('d-none');

                    setTimeout(() => { 
                        $('#contact-modal').modal('hide');
                        // details contact modal 
                        $('#contactModal').modal('hide');
                    }, 4000);

                    if (response.status == true) {
                        form.reset();
                    }
                });
            });
        });

    });

});